export const SIGNATURE_START = '<!-- puresouls-signature:start -->';
export const SIGNATURE_END = '<!-- puresouls-signature:end -->';

export const signatureInputError = (signature) => {
  if (!signature) return 'Email signature is not ready.';
  if (signature.choice === 'custom') {
    if (!signature.custom_name?.trim()) return 'Enter a name for the custom signature.';
    if ([signature.custom_name, signature.custom_title || ''].some(text => text.length > 80 || /[\x00-\x1f\x7f]/.test(text))) {
      return 'Use a single line of up to 80 characters for each signature field.';
    }
  }
  return '';
};

export const hasSignatureBlock = (body = '') => (
  body.split(SIGNATURE_START).length === 2 && body.split(SIGNATURE_END).length === 2
  && body.indexOf(SIGNATURE_END) > body.indexOf(SIGNATURE_START)
);

export const replaceSignatureBlock = (body, signatureHtml) => {
  if (!hasSignatureBlock(body)) throw new Error('The signature section is missing or duplicated. Restore it in the message before changing the signature.');
  const start = body.indexOf(SIGNATURE_START);
  const end = body.indexOf(SIGNATURE_END) + SIGNATURE_END.length;
  return body.slice(0, start) + signatureHtml + body.slice(end);
};

export const getSignatureBlock = (body = '') => hasSignatureBlock(body)
  ? body.slice(body.indexOf(SIGNATURE_START), body.indexOf(SIGNATURE_END) + SIGNATURE_END.length)
  : '';

export const updateAfterpayDraft = (draft, link) => {
  const escaped = link.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  let found = false;
  const renderedBody = draft.renderedBody.replace(
    /(<a\b(?=[^>]*\bdata-puresouls-afterpay-link="true")[^>]*\bhref=")[^"]*(")/gi,
    (_, before, after) => { found = true; return before + escaped + after; },
  );
  return { ...draft, afterpayLink: link, renderedBody, afterpayError: found ? '' : 'The AfterPay link is missing from the message. Restore it before sending.' };
};